export default "__VITE_ASSET__PPGPhqDi__"